import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import NativeCapability from '~/constants/vdp/nativeCapability';
import { useIsNativeCapabilityActive } from '~/context/common/NativeContext';
import ModalContext from '~/context/vdp/ModalContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import sendMessageToNative from './sendMessageToNative';

export default function useFullscreenDispatcher() {
  const {
    isAnyModalOpen,
    isGeolocationModalOpen,
    isReservableCancelModalOpen,
    isReturnPolicyModalOpen,
    isSoftPullModalOpen
  } = useContext(ModalContext);
  const { isSpinnerImmersive } = useContext(SpinnerContext);
  const shouldUseGeolocationWebView = useIsNativeCapabilityActive(
    NativeCapability.GeolocationWebView
  );
  const isNativeModalOpen =
    (isGeolocationModalOpen && !shouldUseGeolocationWebView) ||
    isReservableCancelModalOpen ||
    isReturnPolicyModalOpen ||
    isSoftPullModalOpen;
  const isWebModalOpen = isAnyModalOpen && !isNativeModalOpen;
  const isFullscreen = isSpinnerImmersive || isWebModalOpen;

  useSubsequentEffect(() => {
    sendMessageToNative(
      isFullscreen
        ? DispatcherEvent.EnterFullscreen
        : DispatcherEvent.LeaveFullscreen,
      {}
    );
  }, [isFullscreen]);
}
